<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="dropdown">
    <div class="emd-select toggle" (click)="toggleDropdown()">
        <p>{{ label }}</p>
        <div class="emd-select__arrow"></div>
        <div class="green-dot" *ngIf="isAnySelected()"></div>
    </div>
    @if (isDropdownOpen) {
        <div class="dropdown-menu">
            @for (status of statuses; track $index) {
                <div class="dropdown-item" (click)="onStatusChange(status)">
                    <label for="status" class="mr-2">{{ status.name }}</label>
                    <input type="checkbox" [checked]="status.selected" />
                </div>
            }
        </div>
    }
</div>
